import { type BoundingBoxDto } from '@pkgs/api';

// Germany bounding box (used if no placeId or bounding box is provided)
export const DEFAULT_MAP_BOUNDING_BOX: BoundingBoxDto = {
  northEast: {
    lat: 55.0815,
    lng: 15.041_896_2,
  },
  southWest: {
    lat: 47.270_114,
    lng: 5.866_342_5,
  },
};

export const DEFAULT_MAP_BOUNDING_BOX_EXTENDED: BoundingBoxDto = {
  southWest: {
    lat: 29.688_55,
    lng: 0.541_280_199_999_999_2,
  },
  northEast: {
    lat: 52.893_15,
    lng: 24.883_039_800_000_002,
  },
};

export const DEFAULT_MAP_BOUNDING_BOX_AMERICAS: BoundingBoxDto = {
  southWest: {
    lat: -5.878_332_109_674_314,
    lng: -126.210_937_500_000_01,
  },
  northEast: {
    lat: 62.308_793_691_028_05,
    lng: -63.632_812_500_000_01,
  },
};

export const DEFAULT_MAP_BOUNDING_BOX_EUROPE: BoundingBoxDto = {
  southWest: {
    lat: 21.544_494_666_155_58,
    lng: -20.538_920_204_916_863,
  },
  northEast: {
    lat: 65.433_393_322_243_48,
    lng: 26.886_430_176_912_37,
  },
};
